import type { FunctionComponent } from "preact";
import { useCarouselScrollX } from "@hooks/useCarouselScrollX";
import type { ReactNode } from "preact/compat";

export const Slider: FunctionComponent<{
  children: ReactNode;
  heading: string;
  subheading: string;
  component: ReturnType<typeof useCarouselScrollX>["component"];
  controlsNode: ReactNode;
  container: ReturnType<typeof useCarouselScrollX>["container"];
  wrapper: ReturnType<typeof useCarouselScrollX>["wrapper"];
  handleMouseMove: ReturnType<typeof useCarouselScrollX>["handleMouseMove"];
  startDragging: ReturnType<typeof useCarouselScrollX>["startDragging"];
  stopDragging: ReturnType<typeof useCarouselScrollX>["stopDragging"];
}> = ({
  heading,
  children,
  subheading,
  component,
  container,
  wrapper,
  handleMouseMove,
  startDragging,
  stopDragging,
  controlsNode,
}) => {
  return (
    <div ref={component} className="Slider__component relative w-full h-full">
      <div className="Slider__outter w-full overflow-x-hidden overflow-y-hidden h-full">
        <div
          style={{ willChange: "transform" }}
          className="Slider__container inset-0 h-full w-full pt-0"
        >
          {!!heading && (
            <div className="Slider__heading py-8 flex flex-col items-center justify-center gap-3 text-center">
              <span className="Heading__heading text-lg capitalize">
                {heading}
              </span>
              <div className="mx-auto h-[1px] w-20 bg-black" />
              <h3 className="Heading__subheading text-xl">{subheading}</h3>
            </div>
          )}
          <div
            onMouseDown={startDragging}
            onMouseUp={stopDragging}
            onMouseLeave={stopDragging}
            onMouseMove={handleMouseMove}
            style={{ flexFlow: "row nowrap" }}
            ref={container}
            className="Container h-full relative m-0 flex w-full snap-x snap-proximity list-none items-stretch justify-start overflow-y-auto scroll-smooth"
          >
            <ul ref={wrapper} className="Slider__slides flex items-stretch list-none m-0 p-0">
              {children}
            </ul>
          </div>
          {controlsNode}
        </div>
      </div>
      <style jsx>
        {`
          .Slider__heading {
          }

          .Slider__component {
          }
          .Slider__outter {
          }
          .Indicator[data-state="active"] {
            height: 1.25rem;
            width: 1.25rem;
          }
          .Indicator[data-state="adjacent"] {
            height: 0.75rem;
            width: 0.75rem;
          }
          .Container {
            -ms-overflow-style: none; /* Internet Explorer 10+ */
            scrollbar-width: none; /* Firefox */
          }
          .Container::-webkit-scrollbar {
            display: none; /* Safari and Chrome */
          }
        `}
      </style>
    </div>
  );
};
